import { render, staticRenderFns } from "./EmptyContainer.vue?vue&type=template&id=6507c26b"
import script from "./EmptyContainer.vue?vue&type=script&lang=js"
export * from "./EmptyContainer.vue?vue&type=script&lang=js"
import style0 from "./EmptyContainer.vue?vue&type=style&index=0&id=6507c26b&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports